import { render } from "./QrCodeLabel.vue?vue&type=template&id=4fc7a7e7&scoped=true"
import script from "./QrCodeLabel.vue?vue&type=script&lang=js"
export * from "./QrCodeLabel.vue?vue&type=script&lang=js"

import "./QrCodeLabel.vue?vue&type=style&index=0&id=4fc7a7e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc7a7e7"]])

export default __exports__